import { useNavigate } from "react-router-dom";
import ButtonV2 from "../../common/components/atom/ButtonV2/Button";
import HeaderTitleContent from "../../common/components/atom/HeaderTitleContent/HeaderTitleContent";
import WeeklyReportSubscriptionToggle from "../../features/weeklyReport/components/WeeklyReportSubscriptionToggle";
import { useCapability } from "../../features/rbac";

// Entrées Paramètres filtrées par rôle : configuration équipements = editor+,
// gestion des rôles = admin. Les parcs de luminaires restent visibles de tous
// (lecture + push opérateur) ; le toggle rapport hebdo est personnel.
export default function SettingsPage() {
  const navigate = useNavigate();
  const canEditEquipment = useCapability('equipment.edit');
  const canManageUsers = useCapability('users.manage');

  return (
    <div>
      <HeaderTitleContent>Paramètres</HeaderTitleContent>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginTop: '2rem', maxWidth: '240px' }}>
        {canEditEquipment && (
          <>
            <ButtonV2
              onClick={() => navigate('/main/setting/momi')}
              variant="dashboard-btn-outlined"
              size="medium"
              color="secondary"
            >
              MoMi
            </ButtonV2>
            <ButtonV2
              onClick={() => navigate('/main/setting/luminaires')}
              variant="dashboard-btn-outlined"
              size="medium"
              color="secondary"
            >
              Luminaires
            </ButtonV2>
          </>
        )}
        <ButtonV2
          onClick={() => navigate('/main/setting/fleets')}
          variant="dashboard-btn-outlined"
          size="medium"
          color="secondary"
        >
          Parcs de luminaires
        </ButtonV2>
        {canManageUsers && (
          <ButtonV2
            onClick={() => navigate('/main/setting/roles')}
            variant="dashboard-btn-outlined"
            size="medium"
            color="secondary"
          >
            Rôles & accès
          </ButtonV2>
        )}
      </div>

      {/* Notifications email — toggle abonnement au rapport hebdo Minigrid. */}
      <WeeklyReportSubscriptionToggle />
    </div>
  );
}
